let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aun1P")).then(() => parcelRequire('jzG3I'));